const INITIAL_STATE = {
  data: {},
  errors: {},
}
  
const addPaymentLog = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'ADD_LOG_PAYMENT_SUCCESSFULLY':
	  return { ...state, ...INITIAL_STATE, data: action.data }
  case 'ADD_LOG_PAYMENT_FAILED':
	  return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
	  return { ...state }
  }
};
  
export default addPaymentLog;
  